import { apiClient } from "./client";
import type { RemarkSuggestion, RemarkSuggestionsResult } from "../hooks/useRemarkSuggestions";

// Backend reads behind the remark suggestions (hooks/useRemarkSuggestions).
// apiClient comes through the api/client barrel, so suites that mock the
// barrel still see these requests.

/** Saved remarks ranked for one item (a read, sent as POST). */
export const fetchRemarkSuggestions = (item: unknown) =>
  apiClient.post<RemarkSuggestionsResult>("/saved-remarks/suggest", { item });

/** The most used saved remarks. */
export const fetchPopularRemarks = (limit: number) =>
  apiClient.get<{ remarks: RemarkSuggestion[] }>(`/saved-remarks/popular?limit=${limit}`);
